import { AwardsApi } from '../clients';
import { mapCyclesPage } from '../mappers';

export const getCycles = async (page = 1) =>
  mapCyclesPage(await AwardsApi.getCycles(page));
